import React, { Fragment } from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { X } from 'react-feather'

import { ReportViewer } from './ReportViewer'

export const ModalModule = ({ useFetchInit }) => {

    const { dataModal, toggle } = useFetchInit
    const { open, titleModal, componentModal } = dataModal

    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={toggle}
                fullWidth
                maxWidth='md'
                aria-labelledby='customized-dialog-title'
                tabIndex={-1}
            >
                <DialogTitle id='customized-dialog-title' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {titleModal}
                    <IconButton aria-label='close' onClick={toggle}>
                        <X />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {componentModal === 'ReportViewer' && (
                        <ReportViewer useFetchInit={useFetchInit} />
                    )}
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}
